/**
 * This file was automatically generated by @gctl/openapi-fetchers
 * Do not modify this file, any changes will be destroyed when
 * the command is rerun.
 */

// Group-by-head Select: avoids sibling-key collision when multiple paths share a parent.
// Homomorphic mapped type ([H in keyof Model as ...]) preserves optional/readonly modifiers.
type _PathHead<P> = P extends `${infer H}.${string}` ? H : P;
type _PathTail<P, H extends string> = P extends `${H}.${infer R}` ? R : never;
type _SelectedHeads<Model, Paths extends readonly string[]> = Extract<
  _PathHead<Paths[number]>,
  keyof Model
>;
type _TailsFor<Paths extends readonly string[], H extends string> = Extract<
  _PathTail<Paths[number], H>,
  string
>;

export type Select<Model, Paths extends readonly string[]> = {
  [H in keyof Model as H extends _SelectedHeads<Model, Paths> ? H : never]: H extends Paths[number]
    ? Model[H]
    : NonNullable<Model[H]> extends readonly (infer U)[]
    ? Select<U, _TailsFor<Paths, H & string>[]>[] | Extract<Model[H], null | undefined>
    : NonNullable<Model[H]> extends object
    ?
        | Select<NonNullable<Model[H]>, _TailsFor<Paths, H & string>[]>
        | Extract<Model[H], null | undefined>
    : Model[H];
};

// `_` before a digit is preserved on both sides so digit-flanked wire
// names round-trip (`address_2` <-> `address_2`, `hdr_10_plus` <->
// `hdr_10Plus`). Source shared with the gctl codegen.

export function intoSnakeCase(input: string): string {
  return input
    .split('.')
    .map((seg) =>
      seg
        .replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2')
        .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
        .toLowerCase(),
    )
    .join('.');
}

function intoCamelCase(str: string): string {
  const SENTINEL = '\x00';
  let s = str.replace(/_([0-9])/g, SENTINEL + '$1');
  s = s.replace(/([A-Z]+)([A-Z][a-z])/g, '$1_$2');
  s = s.replace(/([a-z0-9])([A-Z])/g, '$1_$2');
  s = s.toLowerCase().replace(new RegExp(SENTINEL, 'g'), '_');
  const result = s.replace(/[^a-zA-Z0-9]+([a-zA-Z0-9])/g, (match, char) => {
    if (match === '_' + char && char >= '0' && char <= '9') return '_' + char;
    return char.toUpperCase();
  });
  return result.charAt(0).toLowerCase() + result.slice(1);
}

function isDate(x: unknown): x is Date {
  return Object.prototype.toString.call(x) === '[object Date]';
}

function isRegExp(x: unknown): x is RegExp {
  return Object.prototype.toString.call(x) === '[object RegExp]';
}

function isRecord(x: unknown): x is Record<string, unknown> {
  return typeof x === 'object' && !Array.isArray(x) && !isDate(x) && !isRegExp(x) && x !== null;
}

export function deepCamelCase(object: any): any {
  if (!isRecord(object)) {
    return object;
  }

  let result = Object.keys(object).reduce<any>((memo, key) => {
    let value = object[key];

    if (isRecord(value)) {
      value = deepCamelCase(value);
    } else if (Array.isArray(value)) {
      value = value.map(deepCamelCase);
    }

    memo[intoCamelCase(key)] = value;
    return memo;
  }, {});

  return result;
}

export function deepSnakeCase(object: any): any {
  if (!isRecord(object)) {
    return object;
  }

  let result = Object.keys(object).reduce<any>((memo, key) => {
    let value = object[key];

    if (isRecord(value)) {
      value = deepSnakeCase(value);
    } else if (Array.isArray(value)) {
      value = value.map(deepSnakeCase);
    }

    memo[intoSnakeCase(key)] = value;
    return memo;
  }, {});

  return result;
}

export function searchQueryString(query: any) {
  return Object.entries(query ?? {})
    .filter(([, value]) => typeof value !== 'undefined')
    .map(([key, value]) => `${intoSnakeCase(key)}=${encodeURIComponent(value as any)}`)
    .join('&');
}

export class NetworkError extends Error {
  status: number;
  res: Response;

  constructor(message: string, status: number, res: Response) {
    super(message);

    this.name = 'NetworkError';
    this.status = status;
    this.res = res;
  }
}
